import React, { useContext, useEffect, useState } from 'react';
import styles from './Image.module.scss';
import Lottie from 'lottie-react';
import { addCustomPathToLink, getCurrentVariant, sanitizeType } from 'functions';
import { DataContext } from '../../../../views/pages/Root';

const Image = ({ properties, children, type, animationData = {} }) => {
  const data = useContext(DataContext);
  const [animation, setAnimation] = useState();

  useEffect(() => {
    if (properties.animationName && data?.animations2?.length) {
      setAnimation(data.animations2.find((prop) => prop.name === properties.animationName));
    }
  }, [properties.animationName, data]);

  const { src: imageSrc, alt: imageAlt } = properties.image || {};
  const { src: oldImageSrc, alt: oldImageAlt } = properties.old_image || {};

  const hasImage = !!imageSrc;
  const hasOldImage = !!oldImageSrc;

  return (
    (hasImage || hasOldImage) && (
      <>
        <figure
          data-aos={animationData.animation}
          data-aos-delay={animationData.animationDelay}
          data-aos-duration={animationData.animationDuration}
          data-aos-easing={animationData.animationEasing}
          className={`${styles.imageContainer} ${sanitizeType(type, styles)}`}
        >
          {hasImage && <img src={addCustomPathToLink(imageSrc, true)} alt={imageAlt} />}
          {hasOldImage && <img src={addCustomPathToLink(oldImageSrc, true)} alt={oldImageAlt} />}
          {type !== 'leftSide' && animation && <Lottie autoplay animationData={animation.value} loop className={styles.animationOnImage} />}
          {children}
        </figure>
        {type === 'leftSide' && animation && (
          <Lottie autoplay animationData={animation.value} loop className={`${styles.animationOnImage} ${sanitizeType(type, styles)}`} />
        )}
      </>
    )
  );
};

export default Image;
